import styled from 'styled-components'
import { MouseEvent } from 'react'

const Wrapper = styled.div<{
  id?: string
  singleBorder: boolean
  highlight: boolean
  border: boolean
  disabled: boolean
  iconAlignTop: boolean
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
}>`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing.horizontalSpacingS};
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing.verticalSpacingL} ${theme.spacing.horizontalSpacingL}`};
  background-color: ${({ highlight, theme }) => (highlight ? '#FFF9E6' : theme.colors.white)};
  border-radius: 10px;
  ${({ border, singleBorder, theme }) =>
    border
      ? `border: 1px solid ${theme.colors.lightGrey};`
      : singleBorder && `border-bottom: 1px solid #F3F3F3; border-radius: 0;`}

  i {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:hover {
    background-color: #fffbf0;
  }

  ${({ iconAlignTop }) =>
    iconAlignTop &&
    `
   align-items: baseline;
 `}

  ${({ theme, disabled }) =>
    disabled &&
    `
   color: ${theme.colors.darkGrey};
   background-color: ${theme.colors.veryLightGrey};

   &:hover {
     background-color: ${theme.colors.veryLightGrey};
   }

   i {
     color: ${theme.colors.darkGrey};
   }
 `}
`

const Content = styled.div`
  margin-right: auto;
`

export { Wrapper, Content }
